var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAttache = function SvgAttache(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.666 6.424a4.903 4.903 0 0 1 9.806 0v8.805a3.302 3.302 0 0 1-6.604 0V8.825a.5.5 0 0 1 1 0v6.404a2.302 2.302 0 1 0 4.604 0V6.424a3.903 3.903 0 0 0-7.806 0v9.606a5.504 5.504 0 1 0 11.008 0V9.226a.5.5 0 0 1 1 0v6.804a6.504 6.504 0 1 1-13.008 0V6.424Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.666 6.424a4.903 4.903 0 0 1 9.806 0v8.805a3.302 3.302 0 0 1-6.604 0V8.825a.5.5 0 0 1 1 0v6.404a2.302 2.302 0 1 0 4.604 0V6.424a3.903 3.903 0 0 0-7.806 0v9.606a5.504 5.504 0 1 0 11.008 0V9.226a.5.5 0 0 1 1 0v6.804a6.504 6.504 0 1 1-13.008 0V6.424Z",
    fill: "#747F88"
  })));
};

export default SvgAttache;